import React from 'react';

const Taxes: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Taxes</h1>
          <p className="text-gray-600 mt-2">
              Taxes
          </p>
        </div>



        {/* Main Users Image */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="mb-6">
            <img
              src="/images/settings/taxes/taxes.png"
              alt="Users Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Add Custom Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Add Taxes</h2>
          <p className="text-gray-600 mb-4">
            Taxes
          </p>
          <p className="text-gray-600 mb-4">
            To add a taxes:
          </p>
          <ol className="list-decimal list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings</li>
            <li>Select Taxes</li>
            <li>Click the New Taxes button in the top right corner of the page.</li>
            <li>Fill the information about tax</li>
            <li>Click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/taxes/taxes-new.png"
              alt="Add Currency Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Edit Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Edit Taxes</h2>
          <p className="text-gray-600 mb-4">
          After you have added a new currency, you can edit their data if required. Here’s how:
          </p>
          <ol className="list-disc list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings </li>
            <li>Select the role you want to edit and click down arrow button</li>
            <li>Click Edit.</li>
            <li>Make the required changes and click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/taxes/taxes-edit.png"
              alt="Add Custom Currency Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
          <div className="mb-6  mt-6">
            <img
              src="/images/settings/taxes/taxes-edit-save.png"
              alt="Currency Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>



      </div>

    </div>
  );
};

export default Taxes;
